import { z } from 'zod';

export const CrewMemberModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    jobTitle: z.string().optional().nullable(),
    description: z.any().optional().nullable(),
    position: z.number().optional().nullable(),
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
});

export type CrewMemberModel = z.infer<typeof CrewMemberModelSchema>;
